module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uglDW5TMEBazcF9VZGxHvYD",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "uxX2ddj3CuwJ6ebjLu9Csn8"
    }
  }), _vm._v("Note")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Some names have been changed and denoted as such by an asterisk (*).")]), _vm._v(" "), _c('p', {
    staticClass: "Normal _idGenParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Quoted material was taken from printed sources and appears as is. Any mistakes are the original author’s.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-500e9d0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Note.vue
// module id = 78
// module chunks = 0